import React, { useEffect, useState, useMemo, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import "../App.css";
import * as XLSX from 'xlsx';
import '../assets/css/gapsybdmupload.css';
import '../assets/css/Tableproperty.css';
import axios from 'axios';
import mammoth from "mammoth";
import 'bootstrap/dist/css/bootstrap.min.css';
import { Modal, Button, Form } from 'react-bootstrap';
import { bootstrapbuttonclass, cancelButtonStyle, closeButtonStyle, UploadLoadingIcon } from "../components/Propertyfile";
import { templatedata, updatetextfile3001, Makerlist_deptwisetemplates } from '../components/ApiProperty';
import Header from './gapsy-header';
import Navigation from './gapsy-Mnavigation';
import Footer from './gapsy-footer';
import "bootstrap/dist/css/bootstrap.min.css"
import 'bootstrap-icons/font/bootstrap-icons.css';
import styles from '../assets/css/gapsy-dashboard.module.css';
import { useSession } from '../components/SessionContext';



const GapsyResidualModifyRisk = () => {
    const [file, setFile] = useState(null);
    const [uploadStatus, setUploadStatus] = useState('');
    const [uploadProgress, setUploadProgress] = useState(0);
    const [errors, setErrors] = useState([]);
    const fileInputRef = useRef(null);
    const [isValidationPassed, setIsValidationPassed] = useState(false);
    const [columnKeys, setColumnKeys] = useState([]);
    const [selectedDownloadFormat, setSelectedDownloadFormat] = useState(null); // Store selected format
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [Prefix, setPrefix] = useState("");
    const [selectedName, setSelectedName] = useState('');
    const [selectedFile, setSelectedFile] = useState(null);
    const [showDropdown, setShowDropdown] = useState(true);
    const [validRecords, setvalidRecords] = useState("");
    const [validErrorRecords, setvalidErrorRecords] = useState("");
    const [errorMessages, setErrorMessages] = useState([]);
    const [selectedFormat, setSelectedFormat] = useState("");
    const [showDownloadButton, setShowDownloadButton] = useState(false);
    const [errMsg, setErrMsg] = useState('');
    const [loading, setLoading] = useState(false);
    const [loading1, setLoading1] = useState(false);
    const [showPreview, setShowPreview] = useState(false);
    const [isPreviewCompleted, setIsPreviewCompleted] = useState(false);
    const [previewData, setPreviewData] = useState([]); // State for preview data
    const [wsLoading, setWsLoading] = useState(false);
    const [showModal, setShowModal] = useState(false); // State to control modal visibility
    const location = useLocation();
    const [isEactName, setEactName] = useState('');
    const [isExactName, setExactName] = useState('');
    const [modalMessage, setModalMessage] = useState('');
    const [errorModalMessage, setErrorModalMessage] = useState('');
    const [showErrorModal, setShowErrorModal] = useState(false);
    const [showNoDataModal, setShowNoDataModal] = useState(false);
    const [showFileSelectionModal, setShowFileSelectionModal] = useState(false);
    const [fileSelectionMessage, setFileSelectionMessage] = useState('');
    const [isUploadAllowed, setIsUploadAllowed] = useState(true);
    const [columnDetails, setColumnDetails] = useState({});
    const [messageType, setMessageType] = useState(''); // 'success' or 'error'
    const [previewLimit, setPreviewLimit] = useState(100);
    const [columnDropdown, setcolumnDropdown] = useState({});
    const [filteredTables, setFilteredTables] = useState([]);
    const [selectedPrefix, setSelectedPrefix] = useState("");
    const [tableNames, setTableNames] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [recordsPerPage] = useState(7); // Set the number of records per page
    const [searchQuery, setSearchQuery] = useState('');
    const prefixes = Object.keys(tableNames);
    const [isUploading, setIsUploading] = useState(false);
    const [sheetOptions, setSheetOptions] = useState([]);
    const [selectedSheets, setSelectedSheets] = useState([]);
    const [isFileUploaded, setIsFileUploaded] = useState(false);
    const [currentFile, setCurrentFile] = useState(null);
    const [showSheetSelection, setShowSheetSelection] = useState(false);
    const [isTemplateDownloaded, setIsTemplateDownloaded] = useState(false);
    const [isConfirmed, setIsConfirmed] = useState(false);
    const [selectedFileName, setSelectedFileName] = useState('');
    const { sessionId } = useSession();
    let csrfToken = sessionStorage.getItem("tokenizedSession");
    const userId = localStorage.getItem("userid");
    const username = localStorage.getItem("username");
    const [isSubmitted, setIsSubmitted] = useState(false);
    const apiSessionId = sessionStorage.getItem("sessionId");
    const department = sessionStorage.getItem("dept");
    const [selectedNumericColumns, setSelectedNumericColumns] = useState([]);
    const [previewSheetData, setPreviewSheetData] = useState(null);
    const [showmakerRemarks, SetshowMakerremarks] = useState(false);
    const [inputValue, setInputValue] = useState("");
    const [statusData, setStatusData] = useState([]);
    const [reportingRemarks, setReportingRemarks] = useState("");
    const navigate = useNavigate();

    const isNullValue = (value) => {
        if (value == null) return true;

        const v = String(value).trim().toUpperCase();

        return (
            v === "" ||
            v === "\\N" ||
            v === "N" ||
            v === "//N" ||
            v === "NULL"
        );
    };

    const fetchStatusData = async () => {
        const tableNameWithJson = "10192_residual.json";

        try {
            const response = await fetch(
                `/jsonfiles/${tableNameWithJson}`,
                { cache: "no-store" }
            );

            if (!response.ok) {
                setStatusData([]);
                setReportingRemarks("");
                return;
            }

            const data = await response.json();

            setStatusData(data);

            // Reporting date from localStorage
            const reportDate = localStorage.getItem(
                "selectedReportingDate"
            );

            if (!reportDate) {
                setReportingRemarks("");
                return;
            }

            // Find status for selected reporting date
            const currentStatus = data.find(
                item =>
                    item.reporting_date === reportDate
            );

            if (!currentStatus) {
                setReportingRemarks("");
                return;
            }

            // Rejected remark OR submitted remark
            const remarks =
                currentStatus.rejected_remarks ||
                "";

            setReportingRemarks(remarks);

            console.log("Reporting Date:", reportDate);
            console.log("Current Status:", currentStatus);
            console.log("Remarks:", remarks);

        } catch (error) {

            console.error(
                "Error fetching status data:",
                error
            );

            setStatusData([]);
            setReportingRemarks("");
        }
    };

    const [selectedReportingDate, setSelectedReportingDate] = useState(
        () => localStorage.getItem("selectedReportingDate") || ""
    );

    const getQuarterFromReportingDate = (reportingDate) => {
        if (!reportingDate) return "";

        const [year, month, day] = reportingDate.split("-");

        switch (month) {
            case "03":
                return `Q1-${year}`;

            case "06":
                return `Q2-${year}`;

            case "09":
                return `Q3-${year}`;

            case "12":
                return `Q4-${year}`;

            default:
                return "";
        }
    };

    useEffect(() => {
        fetchStatusData();
    }, []);

    const handleDownloadTemplate = async () => {
        if (!selectedReportingDate) return;

        try {
            // Convert reporting date to quarter
            const quarter = getQuarterFromReportingDate(
                selectedReportingDate
            );

            if (!quarter) {
                throw new Error("Invalid reporting date.");
            }

            // Example:
            // 2025-09-30 -> Q3-2025
            const fileName =
                `Residual_Operational_Risk_${quarter}.xlsx`;

            const fileName1 =
                `Residual_Operational_Risk.xlsx`;

            console.log("Downloading file:", fileName);

            const response = await fetch(
                `/uploads/${fileName}`,
                {
                    cache: "no-store"
                }
            );

            if (!response.ok) {
                throw new Error(
                    `Failed to download ${fileName}`
                );
            }

            const blob = await response.blob();

            const url =
                window.URL.createObjectURL(blob);

            const link =
                document.createElement("a");

            link.href = url;
            link.download = fileName1;

            document.body.appendChild(link);

            link.click();

            document.body.removeChild(link);

            window.URL.revokeObjectURL(url);

            setIsTemplateDownloaded(true);

        } catch (error) {

            console.error(
                "Download failed:",
                error
            );

        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        setvalidErrorRecords([]);
        try {
            const config = {
                headers: { "userId": localStorage.getItem('userid'), 'x-csrf-token': csrfToken },
                withCredentials: true,
                params: { dept: department }
            };
            const response = await axios.post(Makerlist_deptwisetemplates, {}, config);

            const message = "Nothing pending for Upload data";

            if (response.data?.tables?.length) {
                // Categorize tables by prefix
                const categorizedTables = {};

                response.data.tables.forEach((table) => {
                    const [prefix, ...rest] = table.split('_');
                    if (!categorizedTables[prefix]) {
                        categorizedTables[prefix] = [];
                    }
                    categorizedTables[prefix].push(table);
                });

                setTableNames(categorizedTables);
            } else {
               
                setTableNames({});
                const dept = sessionStorage.getItem("dept") || "Department not found";
                const updatedMessage = `Nothing pending for Upload data in department: ${dept}`;
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };


    useEffect(() => {
        if (selectedPrefix) {
            // Set the filtered tables based on selectedPrefix
            setFilteredTables(tableNames[selectedPrefix] || []);
        } else {
            setFilteredTables([]); // Clear when no prefix is selected
        }
    }, [selectedPrefix, tableNames]);

    const paginate = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const filteredRecords = useMemo(() => {
        // if (!selectedPrefix) return [];
        if (!selectedPrefix || !tableNames || !tableNames[selectedPrefix]) return [];

        const query = searchQuery.toLowerCase().trim();
        const filteredTablesForPrefix = tableNames[selectedPrefix] || [];

        return filteredTablesForPrefix.filter((tableName) =>
            tableName.toLowerCase().includes(query)
        );
    }, [tableNames, searchQuery, selectedPrefix]);

    useEffect(() => {
        setCurrentPage(1);
    }, [searchQuery]);

    useEffect(() => {
        setCurrentPage(1);
    }, [selectedPrefix]);

    const sortedRecords = useMemo(() => {
        return [...filteredRecords].sort((a, b) => {
            const aStarts = a.toLowerCase().startsWith(searchQuery.toLowerCase());
            const bStarts = b.toLowerCase().startsWith(searchQuery.toLowerCase());
            return bStarts - aStarts;
        });
    }, [filteredRecords, searchQuery]);

    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    const currentRecords = sortedRecords.slice(indexOfFirstRecord, indexOfLastRecord);

    const totalPages = Math.ceil(sortedRecords.length / recordsPerPage);

    const toTitleCase = (str) => {
        return str
            // Replace underscores or hyphens with spaces
            .replace(/[_-]/g, ' ')
            // Add space before capital letters (for camelCase)
            .replace(/([a-z])([A-Z])/g, '$1 $2')
            // Capitalize first letter of each word
            .replace(/\w\S*/g, (w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase());
    };

    const handleCloseNoDataModal = () => setShowNoDataModal(false);

    useEffect(() => {
        if (columnDetails) {
            console.log("Column details updated:", columnDetails);
        }
    }, [columnDetails]);

    const handleBrowseClick = () => {
        if (!selectedReportingDate) return;

        setShowModal(false);

        // Only open the file browser
        fileInputRef.current?.click();
    };


    const handlePreviewOption = async () => {
        try {

            let arrayBuffer;

            // =====================================================
            // USER HAS SELECTED AN EXCEL FILE
            // =====================================================

            if (selectedFile instanceof File) {

                console.log(
                    "Previewing selected file:",
                    selectedFile.name
                );

                arrayBuffer =
                    await selectedFile.arrayBuffer();

            } else {

                // =================================================
                // FETCH SERVER FILE
                // =================================================

                console.log(
                    "Fetching server Excel file..."
                );

                // const fileName =
                //     `Residual_Operational_Risk_${selectedReportingDate}.xlsx`;

                const quarter = getQuarterFromReportingDate(
                    selectedReportingDate
                );

                if (!quarter) {
                    throw new Error(
                        "Invalid reporting date."
                    );
                }

                const fileName =
                    `Residual_Operational_Risk_${quarter}.xlsx`;

                const response = await fetch(
                    `/uploads/${fileName}`,
                    {
                        cache: "no-store"
                    }
                );

                if (!response.ok) {
                    throw new Error(
                        "Failed to fetch Residual_Operational_Risk.xlsx"
                    );
                }

                arrayBuffer =
                    await response.arrayBuffer();
            }

            // =====================================================
            // READ EXCEL
            // =====================================================

            const workbook = XLSX.read(arrayBuffer, {
                type: "array",
                cellStyles: true,
                cellNF: true,
                cellDates: true
            });

            const sheetName =
                "Residual Operational Risk";

            const worksheet =
                workbook.Sheets[sheetName];

            if (!worksheet) {
                throw new Error(
                    `Sheet "${sheetName}" not found`
                );
            }

            const tableRanges = [
                "B3:C6",
                "B8:J15",
                "B17:J22",
                "B26:E29",
                "B32:G33",
                "B40:I50",
                "B53:F63"
            ];

            const html = tableRanges
                .map(range =>
                    renderExcelTable(
                        worksheet,
                        range
                    )
                )
                .join("");

            setPreviewSheetData(html);
            setIsPreviewCompleted(true);
            setShowPreview(true);
            // setShowModal(true);

        } catch (error) {

            console.error(
                "Preview error:",
                error
            );

            setModalMessage(
                `Error previewing Residual_Operational_Risk.xlsx: ${error.message}`
            );

            setShowModal(true);
        }
    };

    const getCellStyle = (cell, cellAddress) => {
        const style = {};

        if (!cell) {
            return style;
        }

        const value =
            cell.v !== undefined && cell.v !== null
                ? String(cell.v).trim()
                : "";

        // ==========================================
        // DEFAULT EXCEL-LIKE STYLE
        // ==========================================
        style.fontFamily = "Calibri, Arial, sans-serif";
        style.fontSize = "11pt";
        style.verticalAlign = "middle";

        // ==========================================
        // MILD
        // ==========================================
        if (value.toLowerCase() === "mild") {
            style.backgroundColor = "#E5EDD3";
            style.fontWeight = "bold";
            style.textAlign = "center";
        }

        // ==========================================
        // MODERATE
        // ==========================================
        else if (value.toLowerCase() === "moderate") {
            style.backgroundColor = "#FFFFC9";
            style.fontWeight = "bold";
            style.textAlign = "center";
        }

        // ==========================================
        // SEVERE
        // ==========================================
        else if (value.toLowerCase() === "severe") {
            style.backgroundColor = "#FFD9DA";
            style.fontWeight = "bold";
            style.textAlign = "center";
        }

        // ==========================================
        // HELPER - CHECK EXCEL CELL RANGE
        // ==========================================
        const isCellInRange = (
            cellAddress,
            startAddress,
            endAddress
        ) => {
            if (!cellAddress) {
                return false;
            }

            const cellRef =
                XLSX.utils.decode_cell(cellAddress);

            const startRef =
                XLSX.utils.decode_cell(startAddress);

            const endRef =
                XLSX.utils.decode_cell(endAddress);

            return (
                cellRef.r >= startRef.r &&
                cellRef.r <= endRef.r &&
                cellRef.c >= startRef.c &&
                cellRef.c <= endRef.c
            );
        };

        // ==========================================
        // BCM HEADER
        // B40:I41
        // ==========================================
        if (
            isCellInRange(
                cellAddress,
                "B40",
                "I41"
            )
        ) {
            style.backgroundColor = "#FFFF00";
            style.fontWeight = "bold";
            style.textAlign = "center";
        }

        // ==========================================
        // BCM CALCULATION / RESULT CELLS
        // B42:I50
        // ==========================================
        if (
            isCellInRange(
                cellAddress,
                "B42",
                "I50"
            )
        ) {
            if (
                value !== "" &&
                !isNaN(Number(value))
            ) {
                style.backgroundColor = "#92D050";
            }
        }

        // ==========================================
        // FINAL CHARGE / RESULT AREA
        // B53:F63
        // ==========================================
        if (
            isCellInRange(
                cellAddress,
                "B53",
                "F63"
            )
        ) {
            if (
                value !== "" &&
                !isNaN(Number(value))
            ) {
                style.backgroundColor = "#FFFFCC";
            }
        }

        // ==========================================
        // EXCEL ALIGNMENT
        // ==========================================
        if (cell.s?.alignment) {
            if (cell.s.alignment.horizontal) {
                style.textAlign =
                    cell.s.alignment.horizontal;
            }

            if (cell.s.alignment.vertical) {
                style.verticalAlign =
                    cell.s.alignment.vertical;
            }

            if (cell.s.alignment.wrapText) {
                style.whiteSpace = "normal";
            }
        }

        // ==========================================
        // EXCEL FONT
        // ==========================================
        if (cell.s?.font) {
            if (cell.s.font.bold) {
                style.fontWeight = "bold";
            }

            if (cell.s.font.italic) {
                style.fontStyle = "italic";
            }

            if (cell.s.font.sz) {
                style.fontSize =
                    `${cell.s.font.sz}pt`;
            }
        }

        return style;
    };

    const styleObjectToString = (style) => {
        return Object.entries(style)
            .map(([key, value]) => {
                const cssKey = key.replace(
                    /[A-Z]/g,
                    match => `-${match.toLowerCase()}`
                );

                return `${cssKey}:${value}`;
            })
            .join(";");
    };


    const getMergedCellInfo = (
        worksheet,
        cellAddress
    ) => {
        const merges = worksheet["!merges"] || [];

        for (const merge of merges) {
            const start = XLSX.utils.encode_cell(
                merge.s
            );

            const end = XLSX.utils.encode_cell(
                merge.e
            );

            const range = XLSX.utils.decode_range(
                `${start}:${end}`
            );

            const target = XLSX.utils.decode_cell(
                cellAddress
            );

            if (
                target.r >= range.s.r &&
                target.r <= range.e.r &&
                target.c >= range.s.c &&
                target.c <= range.e.c
            ) {
                const isTopLeft =
                    target.r === range.s.r &&
                    target.c === range.s.c;

                return {
                    isMerged: true,
                    isTopLeft,
                    rowSpan:
                        range.e.r - range.s.r + 1,
                    colSpan:
                        range.e.c - range.s.c + 1
                };
            }
        }

        return {
            isMerged: false,
            isTopLeft: true,
            rowSpan: 1,
            colSpan: 1
        };
    };


    const escapeHtml = (value) => {
        return String(value)
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/"/g, "&quot;")
            .replace(/'/g, "&#039;");
    };

    const renderExcelTable = (
        worksheet,
        rangeAddress
    ) => {
        const range =
            XLSX.utils.decode_range(rangeAddress);

        let html = `
        <div class="excel-table-section">
            <table class="excel-real-table">
                <tbody>
    `;

        /*
         * Track merged cells that are already rendered.
         */
        const skippedCells = new Set();

        for (
            let row = range.s.r;
            row <= range.e.r;
            row++
        ) {
            html += "<tr>";

            for (
                let col = range.s.c;
                col <= range.e.c;
                col++
            ) {
                const address =
                    XLSX.utils.encode_cell({
                        r: row,
                        c: col
                    });

                if (skippedCells.has(address)) {
                    continue;
                }

                const cell =
                    worksheet[address];

                const mergeInfo =
                    getMergedCellInfo(
                        worksheet,
                        address
                    );

                /*
                 * If this is part of a merged cell but
                 * isn't the top-left cell, don't render it.
                 */
                if (
                    mergeInfo.isMerged &&
                    !mergeInfo.isTopLeft
                ) {
                    continue;
                }

                /*
                 * Mark merged cells as already handled.
                 */
                if (mergeInfo.isMerged) {
                    const mergeStart =
                        XLSX.utils.decode_cell(address);

                    for (
                        let mr = mergeStart.r;
                        mr < mergeStart.r + mergeInfo.rowSpan;
                        mr++
                    ) {
                        for (
                            let mc = mergeStart.c;
                            mc < mergeStart.c + mergeInfo.colSpan;
                            mc++
                        ) {
                            const mergedAddress =
                                XLSX.utils.encode_cell({
                                    r: mr,
                                    c: mc
                                });

                            if (mergedAddress !== address) {
                                skippedCells.add(mergedAddress);
                            }
                        }
                    }
                }

                /*
                 * Excel value
                 */
                let value = "";

                if (cell) {
                    if (
                        cell.v !== undefined &&
                        cell.v !== null
                    ) {
                        value =
                            escapeHtml(
                                XLSX.utils.format_cell(
                                    cell
                                )
                            );
                    }
                }

                const style =
                    getCellStyle(cell, address);
                /*
                 * Give cells their actual Excel
                 * dimensions as much as possible.
                 */
                const columnWidth =
                    worksheet["!cols"]?.[col]?.wch;

                if (columnWidth) {
                    style.width =
                        `${Math.max(
                            columnWidth * 7,
                            35
                        )}px`;
                }

                const rowHeight =
                    worksheet["!rows"]?.[row]?.h;

                if (rowHeight) {
                    style.height =
                        `${rowHeight}px`;
                }

                html += `
                <td
                    ${mergeInfo.colSpan > 1
                        ? `colspan="${mergeInfo.colSpan}"`
                        : ""}
                    ${mergeInfo.rowSpan > 1
                        ? `rowspan="${mergeInfo.rowSpan}"`
                        : ""}
                    style="${styleObjectToString(
                            style
                        )}"
                >
                    ${value}
                </td>
            `;
            }

            html += "</tr>";
        }

        html += `
                </tbody>
            </table>
        </div>
    `;

        return html;
    };

    const handleCloseErrorModal = () => {
        setShowErrorModal(false);
        setUploadStatus('');
        setIsUploadAllowed(true);
    };

    const handleCloseSuccessModal = () => {
        setShowModal(false);
        setIsPreviewCompleted(false);
        // Clear remarks
        setInputValue("");
        setReportingRemarks("");
        // Clear selected file
        setSelectedFile(null);

        // Clear preview
        setShowPreview(false);

        // Clear reporting date
        setSelectedReportingDate("");
        localStorage.removeItem("selectedReportingDate");

        // Reset submission process
        setIsTemplateDownloaded(false);
        setIsFileUploaded(false);
        setIsConfirmed(false);
        setIsSubmitted(false);

        // Clear file input
        if (fileInputRef.current) {
            fileInputRef.current.value = "";
        }
    };

    const validateDropdownValues = async (csvData, fileResponse) => {
        const totalRows = csvData.rows.length - 1; // Exclude header
        const batchSize = 25000; // Major batch splitting
        const totalBatches = Math.ceil(totalRows / batchSize);

        if (!fileResponse?.details?.length) {
            console.warn("JSON file missing 'details', skipping validation.");
            return true;
        }

        const dropdownColumns = {};
        const columnLengths = {};
        const columnTypes = {};
        const columnKeys = {};

        const dateColumnIndices = [];
        const intColumnIndices = [];
        const decimalColumnIndices = [];
        const booleanColumnIndices = [];
        const doubleColumnIndices = [];
        const characterColumnIndices = [];
        const floatColumnIndices = [];

        fileResponse.details.forEach((col, idx) => {
            const key = col.columnName.trim().toLowerCase();
            columnTypes[key] = col.columnType?.toLowerCase();
            columnKeys[key] = col.columnKey?.toLowerCase();

            if (typeof col.columnFunction === 'string') {
                const dropdownMatch = col.columnFunction.match(/dropdown:\[(.*?)\]/i);
                if (dropdownMatch) {
                    dropdownColumns[key] = dropdownMatch[1].split(",").map(val => val.trim().toUpperCase()).filter(Boolean);
                }
            }

            if (col.columnLength) {
                if (typeof col.columnLength === 'string' && col.columnLength.includes(',')) {
                    const [precision, scale] = col.columnLength.split(',').map(num => parseInt(num.trim(), 10));
                    columnLengths[key] = { precision, scale };
                } else {
                    columnLengths[key] = parseInt(col.columnLength, 10);
                }
            }

            switch (col.columnType?.toLowerCase()) {
                case "date": dateColumnIndices.push(idx); break;
                case "integer": intColumnIndices.push(idx); break;
                case "decimal": decimalColumnIndices.push(idx); break;
                case "float": floatColumnIndices.push(idx); break;
                case "boolean": booleanColumnIndices.push(idx); break;
                case "double": doubleColumnIndices.push(idx); break;
                case "character": characterColumnIndices.push(idx); break;
            }
        });

        const parsedRows = new Map();

        // ✨ New internal chunk-based validateBatch

        // Expected headers from template
        const expectedHeaders = fileResponse.details.map(col =>
            col.columnName.trim().toLowerCase()
        );

        // Actual uploaded headers
        const uploadedHeaders = csvData.headers.map(h =>
            h.trim().toLowerCase()
        );

        // Find missing headers
        const missingHeaders = expectedHeaders.filter(
            h => !uploadedHeaders.includes(h)
        );

        console.log("Missing Headers:", missingHeaders);



        const processErrorsBatch = async (start, end) => {
            const batchErrors = [];
            const primaryKeyColumns = Object.keys(columnKeys).filter(k => columnKeys[k] === "primary key");

            const chunkSize = totalRows > 100000 ? 1000 : totalRows > 50000 ? 2000 : 5000;
            const dateFormatRegex = /^\d{4}-\d{2}-\d{2}$/;
            const exponentialRegex = /^[+-]?\d+(\.\d+)?[eE][+-]?\d+$/;

            const uniqueRows = new Map();
            const duplicateEntries = [];

            for (let i = start; i < end; i += chunkSize) {
                const chunkEnd = Math.min(i + chunkSize, end);

                for (let rowIndex = i; rowIndex < chunkEnd; rowIndex++) {
                    const row = csvData.rows[rowIndex + 1];
                    if (!parsedRows.has(rowIndex)) {
                        const matches = [...row.matchAll(/(?<=^|,)(?:"([^"]*)"|([^,]*))(?=,|$)/g)].map(m => m[1] ?? m[2] ?? '');
                        parsedRows.set(rowIndex, matches);
                    }
                    const matches = parsedRows.get(rowIndex);

                    const lineNumber = rowIndex + 1;
                    const errorMessages = [];

                    // Duplicate entry check
                    const cleanedRow = row.trim();
                    // const primaryKeyValues = primaryKeyColumns.map(pk => matches[csvData.headers.indexOf(pk)]).join(",");

                    const primaryKeyValues = primaryKeyColumns.map((pk) => {
                        const colIndex = csvData.headers.indexOf(pk);
                        if (colIndex === -1) {
                            return `${pk} (header missing)`;
                        }

                        const value = matches[colIndex]?.trim();
                        if (!value) {
                            return `Column ${colIndex + 1}`;
                        }

                        return value;
                    }).join(", ");

                    if (uniqueRows.has(cleanedRow)) {
                        errorMessages.push(`Duplicate entry found for primary key: ${primaryKeyValues}.`);
                    } else {
                        uniqueRows.set(cleanedRow, primaryKeyValues);
                    }

                    // Loop through columns and perform validations
                    csvData.headers.forEach((header, columnIndex) => {
                        const columnName = header.trim().toLowerCase();
                        let cellValue = matches[columnIndex]?.trim() || '';

                        // Invalid value check (dropdown)
                        if (dropdownColumns[columnName] && !dropdownColumns[columnName].includes(cellValue.toUpperCase())) {
                            errorMessages.push(`Column '${columnName}' has invalid dropdown value '${cellValue}'.`);
                        }

                        // Required field check (Primary key or Not null)
                        // if ((columnKeys[columnName] === 'primary key' || columnKeys[columnName] === 'not null') && !cellValue) {
                        //   errorMessages.push(`Column '${columnName}' is required but missing.`);
                        // }


                        // Column length check
                        if (columnLengths[columnName]) {
                            const maxLen = columnLengths[columnName];
                            const formatted = cellValue.replace(/\(([^)]+)\)/g, "-$1");
                            const actualLength = formatted.length;

                            if (typeof maxLen === 'object') {
                                const { precision, scale } = maxLen;
                                const [intPart, decPart = ''] = formatted.replace(/[^\d.]/g, '').split('.');
                                const totalDigits = intPart.length + decPart.length;
                                if (totalDigits > precision || decPart.length > scale) {
                                    errorMessages.push(`Column '${columnName}' exceeds precision/scale.`);
                                }
                            } else if (actualLength > maxLen) {
                                errorMessages.push(`Column '${columnName}' exceeds length ${maxLen}.`);
                            }
                        }

                        // Check for column type mismatch (based on expected type)
                        const detectedFormat = detectValueFormat(cellValue).toLowerCase();
                        let expectedType = getColumnTypeFromDetails(columnName.toLowerCase());

                        // Exponential value validation (specific columns)
                        if (exponentialRegex.test(cellValue)) {
                            let columnType = "unknown";
                            if (columnDetails?.double_columns?.[0]?.col_name.some(col => col.toLowerCase() === columnName)) {
                                columnType = "double";
                            } else if (columnDetails?.decimal_columns?.[0]?.col_name.some(col => col.toLowerCase() === columnName)) {
                                columnType = "decimal";
                            } else if (columnDetails?.float_columns?.[0]?.col_name.some(col => col.toLowerCase() === columnName)) {
                                columnType = "float";
                            } else if (columnDetails?.int_columns?.[0]?.col_name.some(col => col.toLowerCase() === columnName)) {
                                columnType = "int";
                            } else if (columnDetails?.varchar_columns?.[0]?.col_name.some(col => col.toLowerCase() === columnName)) {
                                columnType = "varchar";
                            } else if (columnDetails?.number_columns?.[0]?.col_name.some(col => col.toLowerCase() === columnName)) {
                                columnType = "number";
                            } else if (columnDetails?.boolean_columns?.[0]?.col_name.some(col => col.toLowerCase() === columnName)) {
                                columnType = "boolean";
                            } else if (columnDetails?.date_columns?.[0]?.col_name.some(col => col.toLowerCase() === columnName)) {
                                columnType = "date";
                            }

                            if (!["double", "decimal", "float"].includes(columnType)) {
                                errorMessages.push(`Column '${columnName}' contains an Exponential value '${cellValue}' which is not allowed.`);
                            }
                        }

                        if ((columnKeys[columnName] === 'primary key' || columnKeys[columnName] === 'not null') && !cellValue) {
                            errorMessages.push(`Column '${columnName}' is required but missing.`);
                        }
                        // Check for specific column type mismatches
                        if (cellValue !== "") {
                            if (expectedType === "int") {
                                if (detectValueFormat(cellValue) !== "int") {
                                    errorMessages.push(`Column '${columnName}' should be Integer but found: ${cellValue}`);
                                }

                            }
                            else if (["decimal", "double", "float", "number"].includes(expectedType)) {
                                let sanitized = cellValue.replace(/-\s+/g, '-').replace(/,/g, '');

                                if (/^\(\d+(\.\d+)?\)$/.test(sanitized)) {
                                    sanitized = '-' + sanitized.replace(/[()]/g, '');
                                }
                                const numericValue = Number(sanitized);

                                if (isNaN(numericValue) || cellValue.trim() === "") {
                                    errorMessages.push(`Column '${columnName}' should be a valid number but found: ${cellValue}`);
                                }


                            } else if (expectedType === "date") {
                                if (detectValueFormat(cellValue) !== "date") {
                                    errorMessages.push(`Column '${columnName}' should be in YYYY-MM-DD format but found: ${cellValue}`);
                                }
                            } else if (expectedType === "boolean") {
                                if (detectValueFormat(cellValue) !== "boolean") {
                                    errorMessages.push(`Column '${columnName}' should be true or false but found: ${cellValue}`);
                                }
                            }
                            // varchar: allow any value (no check)
                        }
                    });

                    // Add errors for this row if there are any
                    if (errorMessages.length > 0) {
                        // batchErrors.push(`${lineNumber}|${primaryKeyValues}|${errorMessages.join(' # ')}`);
                        batchErrors.push(`${primaryKeyValues}|Error at Line ${lineNumber}:# ${errorMessages.join(' # ')}`);
                    }
                }
            }

            // Process duplicate entries after batch validation
            if (duplicateEntries.length > 0) {
                duplicateEntries.forEach(({ primaryKeyValues, lineNumber }) => {
                    // batchErrors.push(`${primaryKeyValues}|Error at Line ${lineNumber}: # Duplicate entry found.`);
                    batchErrors.push(`${primaryKeyValues}|Error at Line ${lineNumber}: Duplicate entry found.`);

                });
            }

            return batchErrors;
        };


        const validationPromises = [];
        for (let batchIndex = 0; batchIndex < totalBatches; batchIndex++) {
            const start = batchIndex * batchSize;
            const end = Math.min((batchIndex + 1) * batchSize, totalRows);
            validationPromises.push(processErrorsBatch(start, end)); // Run batches in parallel
        }


        let allErrors = [];
        // Collect errors as batches finish
        const results = await Promise.all(validationPromises);

        results.forEach(batchErrors => {
            if (batchErrors.length > 0) {
                allErrors.push(...batchErrors);
                setErrorMessages(prev => [...(prev || []), ...batchErrors]); // Progressive UI updates
            }
        });


        // const sortedErrors = allErrors.sort((a, b) => parseInt(a.split('|')[0]) - parseInt(b.split('|')[0]));
        const sortedErrors = allErrors.sort((a, b) => parseInt(a.split('|')[1]) - parseInt(b.split('|')[1]));


        if (sortedErrors.length > 0) {
            setErrorMessages(sortedErrors); // Final sorted version
            setIsUploadAllowed(true);
            setvalidErrorRecords(sortedErrors);
            // downloadErrorsAsPDF(sortedErrors)
            console.error("Validation Errors:", sortedErrors);
        } else {
            console.log('No validation errors found!');
        }

        const errorLineNumbers = new Set(
            sortedErrors.map(error => {
                // Extract line number from error message
                const parts = error.split('|');
                const linePart = parts[1]; // Error at Line 3: ...
                const match = linePart.match(/Line (\d+)/);
                return match ? parseInt(match[1], 10) : null;
            }).filter(num => num !== null)
        );

        // Now, collect all valid rows
        const validRows = [];

        for (let rowIndex = 0; rowIndex < totalRows; rowIndex++) {
            const lineNumber = rowIndex + 1;
            if (!errorLineNumbers.has(lineNumber)) {
                validRows.push(csvData.rows[lineNumber]); // Note: rows[0] is usually header
            }
        }

        // Now, format valid rows

        const formattedValidRecords = validRows
            .map(row => {

                const regex = /(?<=^|,)(?:"([^"]*)"|([^,]*))(?=,|$)/g;
                const matches = [...row.matchAll(regex)].map(m => m[1] ?? m[2] ?? '');

                // Convert row into object for easy lookup
                const rowObject = {};
                csvData.headers.forEach((header, index) => {
                    rowObject[header.trim().toLowerCase()] = matches[index]?.trim() || '';
                });

                // Now build full row based on expected template order
                return expectedHeaders.map(columnName => {

                    let value = rowObject[columnName] ?? '';  // If missing → empty

                    const colType = columnTypes[columnName];
                    const colKey = columnKeys[columnName];

                    // Handle negative bracket numbers
                    if (value.startsWith('(') && value.endsWith(')')) {
                        value = `-${value.slice(1, -1)}`;
                    }

                    value = value.replace(/,/g, '');

                    // 🔹 If column completely missing in CSV
                    if (!uploadedHeaders.includes(columnName)) {

                        if (colKey === 'primary key') {
                            return 'DUMMY_PK';   // 🔥 your dummy primary key value
                        }

                        if (['decimal', 'double', 'float', 'integer'].includes(colType)) {
                            return '0';          // numeric dummy
                        }

                        if (colType === 'date') {
                            return '1900-01-01'; // default date
                        }

                        if (colType === 'boolean') {
                            return 'false';
                        }

                        return 'N/A';            // varchar dummy
                    }

                    // 🔹 If value empty but allowed nullable numeric/date
                    if (
                        !value &&
                        (!colKey || colKey === 'null') &&
                        ['decimal', 'double', 'float', 'date'].includes(colType)
                    ) {
                        return '\\N';
                    }

                    return value;
                }).join('|');
            })
            .join('\n');

        // Save final valid records
        setvalidRecords(formattedValidRecords);



        return true;
    };

    function detectValueFormat(value) {
        if (!value || value.trim() === "") return "empty"; // Empty check first

        const lowerValue = value.toLowerCase();
        if (["true", "false"].includes(lowerValue)) return "boolean"; // Boolean check

        const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
        if (dateRegex.test(value)) return "date"; // Strict date format (YYYY-MM-DD)

        // Number checks
        if (!isNaN(value)) {
            if (/^[+-]?\d+$/.test(value)) return "int"; // Exact integer
            if (/^[+-]?\d*\.\d+$/.test(value)) return "decimal"; // Decimal (non-integer)
            if (/^[+-]?\d+(\.\d+)?[eE][+-]?\d+$/.test(value)) return "exponential"; // Exponential number
        }

        return "string"; // Default fallback
    }


    // const getColumnTypeFromDetails = async (columnName) => {
    function getColumnTypeFromDetails(columnName) {
        // Loop through column types in columnDetails
        const columnTypes = [
            { type: "int", key: "int_columns" },
            { type: "decimal", key: "decimal_columns" },
            { type: "date", key: "date_columns" },
            { type: "double", key: "double_columns" },
            { type: "varchar", key: "varchar_columns" },
            { type: "number", key: "number_columns" },
            { type: "float", key: "float_columns" }
        ];

        for (const { type, key } of columnTypes) {
            if (columnDetails?.[key]?.some(col => col.col_name.includes(columnName))) {
                return type;
            }
        }
        return "string"; // Default if not found
    }

    const calculateColumnSum = (rows, columnNames, headers) => {
        const normalizeColumnName = (name) => name.replace(/\s+/g, "").toLowerCase(); // Remove spaces & lowercase

        const columnSums = {};
        const columnCounts = {};

        // Normalize column names for comparison
        const normalizedColumnNames = columnNames.map(normalizeColumnName);

        // Create a mapping of normalized headers to actual headers
        const normalizedHeaders = headers.reduce((acc, header, index) => {
            acc[normalizeColumnName(header)] = index; // Store index of each normalized header
            return acc;
        }, {});

        // Initialize sums and counts for all numeric columns
        normalizedColumnNames.forEach((col) => {
            columnSums[col] = 0;
            columnCounts[col] = 0;
        });

        rows.forEach((row) => {
            const regex = /(?<=^|,)(?:"([^"]*)"|([^,]*))(?=,|$)/g; // Proper CSV parsing
            const rowData = [...row.matchAll(regex)].map(match => match[1] ?? match[2] ?? "").map(cell => cell.trim());

            normalizedColumnNames.forEach((colName) => {
                const colIndex = normalizedHeaders[colName]; // Get correct index

                if (colIndex !== undefined) {
                    let value = rowData[colIndex] || "0";

                    // Convert negative values in parentheses, remove commas
                    // value = value.replace(/\(([^)]+)\)/, "-$1").replace(/,/g, "");
                    value = value.replace(/-\s+/g, '-').replace(/\(([^)]+)\)/, "-$1").replace(/,/g, "");

                    let numericValue = parseFloat(value);

                    if (!isNaN(numericValue)) {
                        columnSums[colName] += numericValue;
                        columnCounts[colName] += 1;
                    }
                }
            });
        });

        return { columnSums, columnCounts };
    };

    const anotherFunction = (event) => {
        const selectedFiles = event.target.files;
        const filenames = Array.from(selectedFiles).map((file) => file.name).join("\n");
        setEactName(filenames); // Update the state with all filenames
        // setExactFileType(Customfilename.type);  // This can also be updated to store file types if needed
    };

    const handleFinalSubmit = async () => {
        try {
            setLoading(true);

            if (!selectedReportingDate) {
                setModalMessage(
                    "Please select a reporting date before uploading."
                );
                setShowModal(true);
                return;
            }

            if (!selectedFile) {
                setModalMessage(
                    "Please select an Excel file before uploading."
                );
                setShowModal(true);
                return;
            }

            // =====================================================
            // GET QUARTER FROM REPORTING DATE
            // Example:
            // 2025-03-31 -> Q1-2025
            // 2025-06-30 -> Q2-2025
            // 2025-09-30 -> Q3-2025
            // 2025-12-31 -> Q4-2025
            // =====================================================

            const quarter = getQuarterFromReportingDate(
                selectedReportingDate
            );

            if (!quarter) {
                throw new Error("Invalid reporting date.");
            }

            // =====================================================
            // FILE NAME
            // =====================================================

            const uploadFileName =
                `Residual_Operational_Risk_${quarter}.xlsx`;

            console.log(
                "Uploading Excel file:",
                uploadFileName
            );

            const formData = new FormData();

            formData.append(
                "file",
                selectedFile,
                uploadFileName
            );

            const response = await axios.post(
                templatedata,
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                        userId: localStorage.getItem("userid"),
                        "x-csrf-token": csrfToken
                    }
                }
            );

            console.log(
                "Upload response:",
                response.data
            );

            if (response.status === 200) {
                console.log(
                    "Excel uploaded successfully:",
                    uploadFileName
                );

                setIsFileUploaded(true);
            }

        } catch (error) {

            console.error(
                "Upload error:",
                error
            );

            setModalMessage(
                error.response?.data?.message ||
                error.message ||
                "Failed to upload Excel file."
            );

            setShowModal(true);

        } finally {
            setLoading(false);
        }
    };

    const handleRemarksSubmit = async () => {
        try {
            setLoading(true);

            const userId = localStorage.getItem("userid");

            if (!userId) {
                throw new Error("User ID not found.");
            }

            if (!selectedReportingDate) {
                throw new Error("Reporting date is not selected.");
            }

            // =====================================================
            // SUBMIT JSON FILE NAME
            // =====================================================

            const statusJsonFile = `${userId}_residual.json`;

            // =====================================================
            // READ EXISTING JSON
            // =====================================================

            let existingData = [];

            try {
                const response = await fetch(
                    `/jsonfiles/${statusJsonFile}`,
                    {
                        cache: "no-store"
                    }
                );

                if (response.ok) {
                    existingData = await response.json();

                    // Safety check
                    if (!Array.isArray(existingData)) {
                        existingData = [];
                    }
                }

            } catch (err) {
                console.log(
                    "Status file doesn't exist. Creating new file."
                );
            }

            // =====================================================
            // FILE NAME BASED ON REPORTING DATE
            // =====================================================

            // const uploadedFileName =
            //     `Residual_Operational_Risk_${selectedReportingDate}.xlsx`;

            const quarter = getQuarterFromReportingDate(
                selectedReportingDate
            );

            const uploadedFileName =
                `Residual_Operational_Risk_${quarter}.xlsx`;

            // =====================================================
            // NEW STATUS OBJECT
            // =====================================================

            const newStatus = {
                reporting_date: String(selectedReportingDate || "").trim(),

                submitted_date:
                    new Date().toISOString().split("T")[0],

                status:
                    "Pending for Checker Review",

                reported_by:
                    userId,

                reviewed_by:
                    "10007",

                submitted_remarks:
                    inputValue,

                tableName:
                    uploadedFileName.replace(".xlsx", "")
            };

            console.log(
                "New submission status:",
                newStatus
            );

            // =====================================================
            // REMOVE EXISTING RECORD FOR SAME REPORTING DATE
            // =====================================================

            const index = existingData.findIndex(
                item =>
                    item.reporting_date ===
                    newStatus.reporting_date
            );

            if (index !== -1) {
                existingData.splice(index, 1);
            }

            // =====================================================
            // INSERT LATEST RECORD FIRST
            // =====================================================

            existingData.unshift(newStatus);

            const statusContent =
                JSON.stringify(
                    existingData,
                    null,
                    2
                );

            // =====================================================
            // SAVE JSON
            // =====================================================

            const updateResponse = await axios.post(
                updatetextfile3001,
                {
                    tableNameWithJson:
                        statusJsonFile,

                    content:
                        statusContent
                },
                {
                    headers: {
                        userId: userId,
                        "x-csrf-token": csrfToken
                    },
                    withCredentials: true
                }
            );

            if (updateResponse.status !== 200) {
                throw new Error(
                    "Failed to create submission status file."
                );
            }

            console.log(
                "Submit JSON updated successfully:",
                statusJsonFile
            );

            // =====================================================
            // SUBMISSION COMPLETED
            // =====================================================

            setIsSubmitted(true);

            setMessageType("success");

            setModalMessage(
                "Data Modified Successfully"
            );

            SetshowMakerremarks(false);

            setShowModal(true);

            setInputValue("");

        } catch (error) {

            console.error(
                "Submit error:",
                error
            );

            setMessageType("error");

            setModalMessage(
                error.response?.data?.message ||
                error.message ||
                "Error while submitting data."
            );

            setShowModal(true);

        } finally {
            setLoading(false);
        }
    };

    const handleFileChange = async (event, columnKeys) => {
        setvalidErrorRecords([]);

        const files = event.target.files;

        if (!files || files.length === 0) {
            setUploadStatus("No file selected.");
            return;
        }

        const selectedFiles = Array.from(files);

        let combinedCsvContent = ""; // Store combined content
        let columnHeaders = null; // For consistent column headers
        let mergedFileNames = []; // Store original file names

        for (const file of selectedFiles) {

            const validExtensions = [
                ".csv",
                ".tsv",
                ".txt",
                ".psv",
                ".xls",
                ".xlsx",
                ".doc",
                ".docx"
            ];

            const fileExtension = file.name
                .split(".")
                .pop()
                .toLowerCase();

            if (!validExtensions.includes(`.${fileExtension}`)) {
                setFileSelectionMessage(
                    `${file.name} - Only CSV, TSV, PSV, TXT, XLS, and XLSX files are allowed.`
                );
                setShowFileSelectionModal(true);
                return;
            }

            // ============================================================
            // DOC / DOCX PROCESSING
            // ============================================================

            if (["doc", "docx"].includes(fileExtension)) {

                if (fileExtension === "doc") {
                    setModalMessage(
                        `${file.name} - .doc format is not supported. Please convert it to .docx and re-upload.`
                    );
                    setShowModal(true);
                    return;
                }

                try {
                    const arrayBuffer = await file.arrayBuffer();

                    const htmlResult = await mammoth.convertToHtml({
                        arrayBuffer
                    });

                    const textResult = await mammoth.extractRawText({
                        arrayBuffer
                    });

                    const html = htmlResult.value;

                    const parser = new DOMParser();
                    const doc = parser.parseFromString(html, "text/html");

                    const tables = doc.querySelectorAll("table");

                    let combinedRows = [];
                    let headerRef = null;

                    if (tables.length > 0) {

                        // Standard processing from HTML tables
                        tables.forEach((table) => {

                            const rows = Array.from(
                                table.querySelectorAll("tr")
                            ).map((tr) =>
                                Array.from(
                                    tr.querySelectorAll("td, th")
                                ).map((cell) =>
                                    cell.textContent
                                        .replace(/\u00A0/g, " ")
                                        .replace(/,/g, "")
                                        .replace(/\s+/g, " ")
                                        .trim()
                                )
                            );

                            for (const row of rows) {

                                if (
                                    !row ||
                                    row.length === 0 ||
                                    row.every((cell) => cell === "")
                                ) {
                                    continue;
                                }

                                if (!headerRef) {
                                    headerRef = row.join("|");
                                    combinedRows.push(headerRef);
                                    continue;
                                }

                                if (row.join("|") === headerRef) {
                                    continue;
                                }

                                combinedRows.push(row.join("|"));
                            }
                        });

                    } else {

                        // Fallback: try reading from raw text
                        const lines = textResult.value
                            .trim()
                            .split("\n")
                            .map((line) => line.trim())
                            .filter(Boolean);

                        if (lines.length < 2) {
                            setModalMessage(
                                `${file.name} has no usable table content.`
                            );
                            setShowModal(true);
                            return;
                        }

                        // Guess header by number of columns
                        const firstRow = lines[0]
                            .split(/\s{2,}|\t+/)
                            .filter(Boolean);

                        const colCount = firstRow.length;

                        const structuredRows = [
                            firstRow.join("|")
                        ];

                        for (let i = 1; i < lines.length; i++) {

                            const values = lines[i]
                                .split(/\s{2,}|\t+/)
                                .filter(Boolean);

                            if (values.length === colCount) {
                                structuredRows.push(
                                    values.join("|")
                                );
                            }
                        }

                        combinedRows = structuredRows;
                    }

                    if (combinedRows.length < 2) {
                        setModalMessage(
                            `${file.name} - Table doesn't contain enough data.`
                        );
                        setShowModal(true);
                        return;
                    }

                    const csvContent = combinedRows.join("\n");

                    await processFileData(
                        csvContent,
                        file.name,
                        columnKeys
                    );

                    continue;

                } catch (error) {

                    setModalMessage(
                        `Error reading ${file.name}: ${error.message}`
                    );
                    setShowModal(true);
                    return;
                }
            }

            // ============================================================
            // EXCEL PROCESSING
            // ============================================================

            if (
                ["xls", "xlsx", "xlsb", "xlsm"].includes(fileExtension)
            ) {

                try {

                    const reader = new FileReader();

                    reader.onload = async (e) => {

                        const data = new Uint8Array(
                            e.target.result
                        );

                        const workbook = XLSX.read(data, {
                            type: "array"
                        });

                        // Show modal with checkboxes for sheet selection
                        setSheetOptions(workbook.SheetNames);

                        setCurrentFile(file);
                        setSelectedFile(file);
                        setSelectedFileName(file.name);
                        setShowSheetSelection(true);

                        // setIsSheetSelected(false);

                        // Store columnKeys for later use
                        setColumnKeys(columnKeys);
                    };

                    reader.readAsArrayBuffer(file);

                } catch (error) {

                    setModalMessage(`${error.message}`);
                    setShowModal(true);
                    return;
                }

            } else {

                // ========================================================
                // CSV / TSV / TXT / PSV PROCESSING
                // ========================================================

                try {

                    let fileText = await file.text();

                    const fileRows = fileText.split("\n");

                    if (!columnHeaders) {

                        columnHeaders = fileRows[0];

                        // Add headers only once
                        combinedCsvContent +=
                            columnHeaders + "\n";
                    }

                    const fileData = fileRows
                        .slice(1)
                        .join("\n");

                    if (fileData.trim() !== "") {

                        combinedCsvContent +=
                            fileData + "\n";

                        // Track original file name
                        mergedFileNames.push(file.name);
                    }

                    // setIsSheetSelected(true);

                } catch (error) {

                    setModalMessage(
                        `Error reading ${file.name}: ${error.message}`
                    );
                    setShowModal(true);
                    return;
                }
            }
        }

        // ================================================================
        // PROCESS MERGED CSV CONTENT
        // ================================================================

        if (combinedCsvContent.trim() !== "") {

            for (const fileName of mergedFileNames) {

                processFileData(
                    combinedCsvContent.trim(),
                    fileName,
                    columnKeys
                );
            }

        } else {

            setUploadStatus(
                "No valid data found after merging."
            );
        }
    };

    const processFileData = async (fileText, fileName, columnKeys) => {
        let fileRows = [];

        if (fileName.endsWith(".tsv") || fileText.includes("\t")) {
            fileRows = convertTsvToCsv(fileText).split("\n");
        } else if (fileName.endsWith(".psv") || fileText.includes("|")) {
            fileRows = convertPsvToCsv(fileText).split("\n");
        } else {
            fileRows = fileText.split("\n");
        }

        fileRows = fileRows.map((row) => row.trim()).filter((row) => row.length > 0);
        if (fileRows.length === 0) return;

        const headers = fileRows[0];
        let combinedCsvContent = [headers, ...fileRows.slice(1)];

        finalizeProcessing(combinedCsvContent, columnKeys);
    };

    const finalizeProcessing = async (combinedCsvContent, columnKeys) => {
        if (!combinedCsvContent || combinedCsvContent.length === 0) {
            setUploadStatus("No valid files selected.");
            return;
        }

        try {
            setLoading1(true);
            setErrMsg("");
            setIsUploadAllowed(true);

            const mergedCsvText = combinedCsvContent.join("\n");

            console.log("Merged CSV:");
            console.log(mergedCsvText);

            const normalizedTableName = selectedName.toLowerCase();
            const finalFileName = `${normalizedTableName}.csv`;

            const mergedFile = new File(
                [mergedCsvText],
                finalFileName,
                {
                    type: "text/csv"
                }
            );

            console.log("Merged file:", mergedFile);

            /*
             * If you are not using convertCsvToTxt currently,
             * use mergedCsvText directly.
             */
            const processedContent = mergedCsvText;

            const processedFile = new File(
                [processedContent],
                finalFileName.replace(".csv", ".txt"),
                {
                    type: "text/plain"
                }
            );

            console.log("Processed file:", processedFile);

            // Run validation
            const csvData = {
                rows: combinedCsvContent,
                headers: combinedCsvContent[0].split(","),
            };

            const dropdownValidationPassed =
                await validateDropdownValues(
                    csvData,
                    processedFile
                );

            console.log(
                "Dropdown validation:",
                dropdownValidationPassed
            );

            // Set selected file
            setFile(processedFile);
            setSelectedFile(processedFile);

            setUploadStatus("");

            if (dropdownValidationPassed) {
                setShowModal(true);
            }

            setIsUploadAllowed(true);

        } catch (error) {
            console.error(
                "Error processing files:",
                error
            );

            setUploadStatus("Error processing files.");
            setIsUploadAllowed(false);

        } finally {
            setLoading1(false);
        }
    };

    const convertTsvToCsv = (tsvText) => {
        const rows = tsvText.split('\n').map(row => row.trim()).filter(row => row.length > 0);
        if (rows.length === 0) {
            throw new Error('No content in file');
        }

        const headers = rows[0].split('\t').map(header => header.trim().toLowerCase());
        const csvData = { headers, rows };


        const convertedContent = rows.map(row => {
            const columns = row.split('\t').map(value => value.trim().replace(/"/g, ''));
            return columns.join(',');
        }).join('\n');

        return convertedContent;
    };

    const convertPsvToCsv = (psvText) => {
        const rows = psvText.split('\n').map(row => row.trim()).filter(row => row.length > 0);
        if (rows.length === 0) {
            throw new Error('No content in file');
        }

        const headers = rows[0].split('|').map(header => header.trim().toLowerCase());
        const csvData = { headers, rows };


        const convertedContent = rows.map(row => {
            const columns = row.split('|').map(value => value.trim().replace(/"/g, ''));
            return columns.join(',');
        }).join('\n');

        return convertedContent;
    };

    const handleCloseMakerPOP = () => {
        SetshowMakerremarks(false);
        setShowModal(false);

        // Clear remarks
        setInputValue("");
        setReportingRemarks("");
        // Clear selected file
        setSelectedFile(null);
        setShowPreview(false);

        // Clear reporting date
        setSelectedReportingDate("");
        localStorage.removeItem("selectedReportingDate");

        // Reset submission process
        setIsTemplateDownloaded(false);
        setIsFileUploaded(false);
        setIsConfirmed(false);
        setIsSubmitted(false);

        // Clear file input
        if (fileInputRef.current) {
            fileInputRef.current.value = "";
        }
    };

    const handleCloseModal = () => {
        setShowPreview(false);
    }

    const handleCancel = () => {
        setShowModal(false);
        setShowNoDataModal(false);
        setShowPreview(false);
        setShowDownloadButton(false);
        setShowDropdown(false);
        setShowSheetSelection(false);

        // Clear only if there are no validation errors
        if (validErrorRecords.length === 0) {
            setSelectedFile(null);  // Only clear file if no validation errors
            setSelectedFormat('');
            setSelectedDownloadFormat('');
            setSelectedCategory('');
            setExactName('');
            setcolumnDropdown({});
            setColumnDetails({});

        }

        setFile(null);
        setCurrentFile(null);
        setUploadStatus('');
        setPreviewData([]);
        setSelectedSheets([]);
        // setJsonReportData([]);
        setSheetOptions([]);
        setColumnKeys([]);
        setSelectedNumericColumns([]);
        setModalMessage('');
        setIsUploadAllowed(false);
        setIsValidationPassed(false);

        if (fileInputRef.current) {
            fileInputRef.current.value = '';
        }
    };

    // Function to detect date-like values (YYYY-MM-DD, YYYY/MM/DD, etc.)
    const isDateValue = (value) => {
        return /^\d{4}[-/]\d{2}[-/]\d{2}$/.test(value.trim()); // Matches formats like 2021-08-25 or 2021/08/25
    };

    // Extract headers
    // Identify date columns dynamically based on the first few data rows
    const dateColumnIndices = [];
    previewData.slice(1, 5).forEach((row) => { // Check first 5 rows for accuracy
        const columns = row.split(",").map(cell => cell.trim());
        columns.forEach((cell, index) => {
            if (isDateValue(cell)) {
                console.log(cell, "+++", index);
                dateColumnIndices.push(index);
            }
        });
    });


    useEffect(() => {
        setSelectedDownloadFormat(null); // Reset selected download format
        setSelectedCategory(null); // Reset selected category
    }, [selectedFormat]);

    return (
        <div
            className={`d-flex flex-column min-vh-100 ${styles.pageFullBackground}`}
            style={{
                backgroundImage: "none",
                backgroundColor: "#ffffff"
            }}
        >
            <Header />
            <Navigation />

            {/* <div className="gapsybdmupload-page"> */}
            <main className="flex-grow-1 container-fluid" style={{ margin: 0, padding: 0, background: "none" }}>
                <div className={styles.mainContainer}>
                    <div className="container-fluid py-2">
                        <div className="row">
                            <div className="row">

                                {loading && (
                                    <div className="loading-overlay">
                                        <UploadLoadingIcon />
                                    </div>
                                )}


                                <>
                                    <div className="card-header bg-primary text-white">
                                        <h5 className="mb-0">
                                            Residual Operational Risk
                                        </h5>
                                    </div>

                                    <div className="row g-2">
                                        <div className="col-lg-4 col-md-12">
                                            <div className={`card h-100 ${styles.cardBorder} ${styles.card}`}>
                                                <div className="card-body">
                                                    <h5 className="mb-4">
                                                        Template Submission Process
                                                    </h5>


                                                    {/* Step 1 */}
                                                    <div className="list-group-item border-0 px-0 py-2">
                                                        <div className="d-flex align-items-center">

                                                            <span
                                                                className={`badge rounded-circle p-2 me-3 ${selectedReportingDate
                                                                    ? "bg-success"
                                                                    : "bg-primary"
                                                                    }`}
                                                            >
                                                                {selectedReportingDate ? (
                                                                    <i className="bi bi-check-lg"></i>
                                                                ) : (
                                                                    "1"
                                                                )}
                                                            </span>

                                                            <div>
                                                                <div className="fw-semibold">
                                                                    Select Reporting Date
                                                                </div>

                                                                <small
                                                                    className={
                                                                        selectedReportingDate
                                                                            ? "text-success"
                                                                            : "text-primary"
                                                                    }
                                                                >
                                                                    {selectedReportingDate
                                                                        ? `Completed - ${getQuarterFromReportingDate(selectedReportingDate)}`
                                                                        : "Current Step"}
                                                                </small>
                                                            </div>

                                                        </div>
                                                    </div>


                                                    {/* Step 2 */}
                                                    <div className="list-group-item border-0 px-0 py-2">
                                                        <div className="d-flex align-items-center">

                                                            <span
                                                                className={`badge rounded-circle p-2 me-3 ${isTemplateDownloaded
                                                                    ? "bg-success"
                                                                    : selectedReportingDate
                                                                        ? "bg-primary"
                                                                        : "bg-secondary"
                                                                    }`}
                                                            >
                                                                {isTemplateDownloaded ? (
                                                                    <i className="bi bi-check-lg"></i>
                                                                ) : (
                                                                    "2"
                                                                )}
                                                            </span>

                                                            <div>
                                                                <div className="fw-semibold">
                                                                    Download Operational Residual Risk Template
                                                                </div>

                                                                <small
                                                                    className={
                                                                        isTemplateDownloaded
                                                                            ? "text-success"
                                                                            : selectedReportingDate
                                                                                ? "text-primary"
                                                                                : "text-muted"
                                                                    }
                                                                >
                                                                    {isTemplateDownloaded
                                                                        ? "Completed"
                                                                        : selectedReportingDate
                                                                            ? "Next Step"
                                                                            : "Pending"}
                                                                </small>
                                                            </div>

                                                        </div>
                                                    </div>

                                                    {/* Step 3 */}
                                                    <div className="list-group-item border-0 px-0 py-2">
                                                        <div className="d-flex align-items-center">

                                                            <span
                                                                className={`badge rounded-circle p-2 me-3 ${isFileUploaded
                                                                    ? "bg-success"
                                                                    : isTemplateDownloaded && selectedFile
                                                                        ? "bg-primary"
                                                                        : "bg-secondary"
                                                                    }`}
                                                            >
                                                                {isFileUploaded ? (
                                                                    <i className="bi bi-check-lg"></i>
                                                                ) : (
                                                                    "3"
                                                                )}
                                                            </span>

                                                            <div>
                                                                <div className="fw-semibold">
                                                                    Upload the latest Operational Risk Residual data
                                                                </div>

                                                                <small
                                                                    className={
                                                                        isFileUploaded
                                                                            ? "text-success"
                                                                            : isTemplateDownloaded && selectedFile
                                                                                ? "text-primary"
                                                                                : "text-muted"
                                                                    }
                                                                >
                                                                    {isFileUploaded
                                                                        ? "Completed"
                                                                        : isTemplateDownloaded && selectedFile
                                                                            ? "Next Step"
                                                                            : "Pending"}
                                                                </small>
                                                            </div>

                                                        </div>
                                                    </div>

                                                    {/* Step 4 */}
                                                    <div className="list-group-item border-0 px-0 py-2">
                                                        <div className="d-flex align-items-center">

                                                            <span
                                                                className={`badge rounded-circle p-2 me-3 ${isPreviewCompleted
                                                                    ? "bg-success"
                                                                    : isFileUploaded
                                                                        ? "bg-primary"
                                                                        : "bg-secondary"
                                                                    }`}
                                                            >
                                                                {isPreviewCompleted ? (
                                                                    <i className="bi bi-check-lg"></i>
                                                                ) : (
                                                                    "4"
                                                                )}
                                                            </span>

                                                            <div>
                                                                <div className="fw-semibold">
                                                                    Preview the uploaded Operational Risk Residual data
                                                                </div>

                                                                <small
                                                                    className={
                                                                        isPreviewCompleted
                                                                            ? "text-success"
                                                                            : isFileUploaded
                                                                                ? "text-primary"
                                                                                : "text-muted"
                                                                    }
                                                                >
                                                                    {isPreviewCompleted
                                                                        ? "Completed"
                                                                        : isFileUploaded
                                                                            ? "Next Step"
                                                                            : "Pending"}
                                                                </small>
                                                            </div>

                                                        </div>
                                                    </div>


                                                    {/* Step 5 - Confirm & Submit */}
                                                    <div className="list-group-item border-0 px-0 py-2">
                                                        <div className="d-flex align-items-center">

                                                            <span
                                                                className={`badge rounded-circle p-2 me-3 ${isSubmitted
                                                                    ? "bg-success"
                                                                    : isPreviewCompleted
                                                                        ? "bg-primary"
                                                                        : "bg-secondary"
                                                                    }`}
                                                            >
                                                                {isSubmitted ? (
                                                                    <i className="bi bi-check-lg"></i>
                                                                ) : (
                                                                    "5"
                                                                )}
                                                            </span>

                                                            <div>
                                                                <div className="fw-semibold">
                                                                    Confirm & Submit - Provide remarks for review and Checker approval
                                                                </div>

                                                                <small
                                                                    className={
                                                                        isSubmitted
                                                                            ? "text-success"
                                                                            : isPreviewCompleted
                                                                                ? "text-primary"
                                                                                : "text-muted"
                                                                    }
                                                                >
                                                                    {isSubmitted
                                                                        ? "Completed"
                                                                        : isPreviewCompleted
                                                                            ? "Provide remarks for review and Checker approval"
                                                                            : "Pending"}
                                                                </small>
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>

                                                {/* </div> */}
                                            </div>
                                        </div>

                                        <div className="col-lg-8 col-md-12">
                                            <div className={`card h-100 ${styles.cardBorder} ${styles.card}`}>
                                                <div className="card-body p-1">

                                                    <h6 className={`pb-1 mb-2 ${styles.borderBottom}`}>
                                                        {selectedFileName
                                                            ?.split('_')
                                                            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                                                            .join(' ')}
                                                    </h6>

                                                    {/* Tab Content */}
                                                    {/* {activeTab === 'manual' && ( */}
                                                    <div className='row'>
                                                        <div className="col-md-6">
                                                            <div
                                                                className={`mb-3 ${styles.supportedFileFormats} p-3`}
                                                                style={{ minHeight: "250px" }}
                                                            >
                                                                {/* Reporting Date */}
                                                                <div className="d-flex align-items-center gap-2 mb-3">
                                                                    <label
                                                                        htmlFor="reportingDate"
                                                                        className="fw-semibold mb-0 text-nowrap"
                                                                    >
                                                                        Reporting Date
                                                                    </label>

                                                                    <input
                                                                        id="reportingDate"
                                                                        type="text"
                                                                        className="form-control form-control-sm"
                                                                        style={{ width: "150px" }}
                                                                        value={
                                                                            getQuarterFromReportingDate(
                                                                                selectedReportingDate
                                                                            )
                                                                        }
                                                                        readOnly
                                                                    />
                                                                </div>

                                                                {/* Remarks */}
                                                                {!isNullValue(reportingRemarks) && (
                                                                    <div className="d-flex align-items-start gap-2 mb-3">
                                                                        <label className="fw-semibold mb-0 text-nowrap">
                                                                            Remarks
                                                                        </label>

                                                                        <span
                                                                            className="text-danger fw-semibold"
                                                                            style={{
                                                                                maxWidth: "500px",
                                                                                wordBreak: "break-word"
                                                                            }}
                                                                        >
                                                                            {reportingRemarks}
                                                                        </span>
                                                                    </div>
                                                                )}

                                                                {/* Download Template */}
                                                                <div className="mt-3">
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-link p-0 text-decoration-none"
                                                                        disabled={!selectedReportingDate}
                                                                        onClick={handleDownloadTemplate}
                                                                    >
                                                                        <i className="bi bi-download me-1"></i>
                                                                        Download Template
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className='col-md-6'>
                                                            <div className="mb-3">
                                                                <div className="flex-grow-1 justify-content-center w-100">
                                                                    <div
                                                                        className={`p-1 mx-2 my-2 ${styles.uploadArea}`}
                                                                        onClick={() => {
                                                                            if (!selectedFile && selectedReportingDate) {
                                                                                handleBrowseClick();
                                                                            }
                                                                        }}
                                                                        style={{
                                                                            cursor: selectedReportingDate ? "pointer" : "not-allowed",
                                                                            opacity: selectedReportingDate ? 1 : 0.5,
                                                                            pointerEvents: selectedReportingDate ? "auto" : "none",
                                                                        }}
                                                                        title={
                                                                            !selectedReportingDate
                                                                                ? "Please select reporting date"
                                                                                : "Click to browse file"
                                                                        }
                                                                    >
                                                                        {!selectedFile && validErrorRecords.length === 0 && (
                                                                            <>
                                                                                <i className="bi bi-cloud-upload fs-1 text-muted mb-2 d-block text-center"></i>
                                                                                <h5 className="mb-1">Upload File</h5>
                                                                                <p className="text-muted mb-0">Click to browse</p>
                                                                            </>
                                                                        )}

                                                                        <div className="text-center" style={{ marginTop: selectedFile ? '37px' : '36px' }}>
                                                                            {selectedFile && (
                                                                                <div
                                                                                    id="fileList"
                                                                                    className="mt-3 mb-3 d-flex align-items-center justify-content-center flex-wrap gap-2"
                                                                                >
                                                                                    <div
                                                                                        id="selectedFiles"
                                                                                        className="text-muted d-flex flex-wrap gap-2 mb-0"
                                                                                    >
                                                                                        {isEactName.split("\n").map((filename, index) => (
                                                                                            <div key={index} className="d-flex flex-column border rounded p-2">
                                                                                                <div><strong>📄 File Name:</strong> {filename}</div>
                                                                                                {selectedFile && (
                                                                                                    <div><strong>📏 File Size:</strong> {selectedFile.size} bytes</div>
                                                                                                )}
                                                                                            </div>
                                                                                        ))}
                                                                                    </div>
                                                                                </div>
                                                                            )}

                                                                            <input
                                                                                type="file"
                                                                                ref={fileInputRef}
                                                                                id="fileInput"
                                                                                style={{ display: "none" }}
                                                                                accept=".xlsx,.xls"
                                                                                disabled={!selectedReportingDate}
                                                                                onChange={(event) => {
                                                                                    if (!selectedReportingDate) return;

                                                                                    const file = event.target.files?.[0];

                                                                                    if (!file) return;

                                                                                    setSelectedFile(file);

                                                                                    // New file has not been uploaded yet
                                                                                    setIsFileUploaded(false);

                                                                                    handleFileChange(event);
                                                                                    anotherFunction(event);
                                                                                }}
                                                                            />
                                                                        </div>
                                                                    </div>

                                                                    <div className="d-flex flex-column align-items-center gap-2 mt-2">
                                                                        {selectedFile && (
                                                                            <div className="d-flex gap-2 mb-3">

                                                                                {/* BEFORE UPLOAD */}
                                                                                {!isFileUploaded && (
                                                                                    <button
                                                                                        onClick={handleFinalSubmit}
                                                                                        className="btn btn-success btn-sm"
                                                                                        disabled={loading}
                                                                                    >
                                                                                        {loading ? "Uploading..." : "Upload"}
                                                                                    </button>
                                                                                )}

                                                                                {/* AFTER UPLOAD */}
                                                                                {isFileUploaded && (
                                                                                    <>
                                                                                        <button
                                                                                            onClick={handlePreviewOption}
                                                                                            className="btn btn-outline-primary btn-sm"
                                                                                        >
                                                                                            Preview
                                                                                        </button>

                                                                                        <button
                                                                                            onClick={() => {
                                                                                                setIsConfirmed(true);
                                                                                                SetshowMakerremarks(true);
                                                                                            }}
                                                                                            className="btn btn-primary btn-sm"
                                                                                        >
                                                                                            Confirm
                                                                                        </button>
                                                                                    </>
                                                                                )}

                                                                                {/* ALWAYS AVAILABLE */}
                                                                                <button
                                                                                    onClick={handleCancel}
                                                                                    className="btn btn-outline-secondary btn-sm"
                                                                                >
                                                                                    Cancel
                                                                                </button>

                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                    {/* )} */}


                                                    {errMsg && (
                                                        <div className="alert alert-danger alert-dismissible fade show" role="alert">
                                                            {errMsg}
                                                            <button type="button" className="close" data-dismiss="alert" aria-label="Close" onClick={() => setErrMsg('')}>
                                                                <span aria-hidden="true">&times;</span>
                                                            </button>
                                                        </div>
                                                    )}
                                                    {loading && (
                                                        <div className="loading-overlay">
                                                            <UploadLoadingIcon />
                                                        </div>

                                                    )}
                                                    {loading1 && (
                                                        <div className="loading-overlay">
                                                            <UploadLoadingIcon />
                                                        </div>

                                                    )}
                                                    {wsLoading && (
                                                        <div className="loading-overlay">
                                                            {/* <div className="spinner-border text-primary" role="status">
                                                      <span className="visually-hidden">Loading...</span>
                                                    </div> */}
                                                            <UploadLoadingIcon />
                                                        </div>
                                                    )}
                                                    {isUploading && (
                                                        <div className="loading-overlay">
                                                            <div className="progress w-50">
                                                                <div
                                                                    className="progress-bar progress-bar-striped progress-bar-animated"
                                                                    role="progressbar"
                                                                    style={{ width: `${uploadProgress}%` }}
                                                                    aria-valuenow={uploadProgress}
                                                                    aria-valuemin="0"
                                                                    aria-valuemax="100"
                                                                >
                                                                    {uploadProgress}%
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}


                                                    <>
                                                        <style>
                                                            {`
        .excel-print-preview {
            background: #f5f5f5;
            padding: 25px;
            overflow-x: auto;
        }

        .excel-table-section {
            background: #ffffff;
            width: fit-content;
            min-width: fit-content;
            margin: 0 auto 28px auto;
            padding: 20px;
            box-shadow: 0 1px 5px rgba(0, 0, 0, 0.12);
        }

        .excel-real-table {
            border-collapse: collapse;
            table-layout: auto;
            width: auto;
            min-width: 0;
        }

        .excel-real-table td {
            border: 1px solid #000;
            padding: 5px 8px;
            white-space: nowrap;
            vertical-align: middle;
            font-family: Calibri, Arial, sans-serif;
            font-size: 11pt;
        }

        .excel-real-table td:empty {
            min-width: 0;
        }
    `}
                                                        </style>

                                                        {/* Your existing page */}

                                                        {showPreview && (
                                                            <Modal
                                                                show={showPreview}
                                                                onHide={handleCloseModal}
                                                                dialogClassName="modal-xl"
                                                                centered
                                                            >
                                                                <Modal.Header className="bg-light border-bottom px-0 py-2">
                                                                    <div className="container-fluid px-0">
                                                                        <div className="row align-items-center w-100 gx-0">

                                                                            <div className="col-auto ps-3">
                                                                                <h6 className="mb-0">
                                                                                    <strong>Table Name:</strong>{" "}
                                                                                    <span>
                                                                                        Residual Operational Risk
                                                                                    </span>
                                                                                </h6>
                                                                            </div>

                                                                            <div className="col-auto ms-auto">
                                                                                <div className="d-flex justify-content-end pe-3">
                                                                                    <button
                                                                                        onClick={handleCloseModal}
                                                                                        type="button"
                                                                                        className="btn-close"
                                                                                        aria-label="Close"
                                                                                    />
                                                                                </div>
                                                                            </div>

                                                                        </div>
                                                                    </div>
                                                                </Modal.Header>

                                                                <Modal.Body
                                                                    style={{
                                                                        overflow: "auto",
                                                                        maxHeight: "75vh",
                                                                        background: "#f5f5f5"
                                                                    }}
                                                                >
                                                                    <div
                                                                        className="excel-print-preview"
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: previewSheetData
                                                                        }}
                                                                    />
                                                                </Modal.Body>
                                                            </Modal>
                                                        )}
                                                    </>

                                                    <Modal show={showErrorModal} onHide={() => setShowErrorModal(false)} centered backdrop="static" keyboard={false}>
                                                        <Modal.Header closeButton>
                                                            <Modal.Title>Error / Warning</Modal.Title>
                                                        </Modal.Header>

                                                        {/* Apply Bootstrap scrolling + max height */}
                                                        <Modal.Body className="text-break overflow-auto" style={{ maxHeight: "60vh" }}>
                                                            {errorModalMessage}
                                                        </Modal.Body>

                                                        <Modal.Footer>
                                                            <Button variant="secondary" style={closeButtonStyle} onClick={handleCloseErrorModal}>
                                                                Close
                                                            </Button>
                                                        </Modal.Footer>
                                                    </Modal>

                                                    <Modal show={showModal} style={{ marginTop: '12vh' }}>
                                                        <div className={`alert alert-${messageType === 'success' ? 'success' : 'danger'} fade show`} role="alert"
                                                            style={{ marginBottom: '0', maxHeight: '80vh', overflowY: 'auto' }}>

                                                            <div className="d-flex align-items-center">
                                                                {messageType === 'success' ? (
                                                                    <span className="me-2" style={{ color: 'green' }}>✅</span>
                                                                ) : (
                                                                    <span className="me-2" style={{ color: 'red' }}>❌</span>
                                                                )}
                                                                <p
                                                                    style={{
                                                                        marginBottom: '0px',
                                                                        color: messageType === 'success' ? 'green' : 'red',
                                                                        fontSize: '14px',
                                                                        whiteSpace: 'pre-wrap' // optional, if you want to preserve spaces or indentation
                                                                    }}
                                                                    dangerouslySetInnerHTML={{
                                                                        __html: modalMessage.replace(/\n/g, '<br />')
                                                                    }}
                                                                ></p>



                                                            </div>
                                                            <button
                                                                type="button"
                                                                className="btn-close position-absolute top-0 end-0 m-2" style={{ fontSize: '10px' }}
                                                                onClick={handleCloseSuccessModal}>
                                                            </button>

                                                        </div>
                                                    </Modal>


                                                    <Modal
                                                        show={showNoDataModal}
                                                        onHide={handleCloseNoDataModal}
                                                        dialogClassName="modal-narrow" // Adjust if needed

                                                        style={{ marginTop: '12vh' }}
                                                    >
                                                        <Modal.Header closeButton>
                                                            <Modal.Title>Template Preview</Modal.Title>
                                                        </Modal.Header>
                                                        <Modal.Body>
                                                            <p>No preview data available. Please upload a file with valid data.</p>
                                                        </Modal.Body>
                                                        <Modal.Footer>
                                                            <button
                                                                className={bootstrapbuttonclass}
                                                                style={

                                                                    closeButtonStyle
                                                                }
                                                                onClick={handleCloseNoDataModal}>Close</button>
                                                        </Modal.Footer>
                                                    </Modal>

                                                    <Modal show={showmakerRemarks} onHide={handleCloseMakerPOP} centered backdrop="static" keyboard={false}>
                                                        <Modal.Header
                                                            style={{
                                                                backgroundColor: '#366872',
                                                                color: 'white',
                                                                padding: '0.5rem 1rem'
                                                            }}
                                                        >
                                                            <Modal.Title style={{ fontSize: '16px' }}>Remarks</Modal.Title>
                                                        </Modal.Header>

                                                        <Modal.Body className="text-break overflow-auto" style={{ padding: '0.75rem 1rem', fontSize: '14px', maxHeight: "60vh" }}>
                                                            <Form.Control
                                                                type="text"
                                                                placeholder="Enter your remarks"
                                                                value={inputValue}
                                                                onChange={(e) => setInputValue(e.target.value)}
                                                            />
                                                        </Modal.Body>

                                                        <Modal.Footer style={{ borderTop: 'none' }}>
                                                            <Button variant="btn btn-outline-secondary btn-sm mx-2" style={cancelButtonStyle} onClick={handleCloseMakerPOP}>
                                                                Close
                                                            </Button>
                                                            <Button variant="btn btn-success btn-sm mx-2" onClick={handleRemarksSubmit}>
                                                                Submit
                                                            </Button>
                                                        </Modal.Footer>
                                                    </Modal>

                                                    <Modal show={showFileSelectionModal} onHide={() => setShowFileSelectionModal(false)}
                                                        backdrop="static" keyboard={false} style={{ marginTop: '12vh' }}>
                                                        <Modal.Header style={{
                                                            backgroundColor: '#366872',
                                                            color: 'white',
                                                            padding: '0.5rem 1rem'
                                                        }}>
                                                            <Modal.Title style={{ fontSize: '16px' }}>Notification</Modal.Title>
                                                        </Modal.Header>
                                                        <Modal.Body style={{ padding: '0.75rem 1rem', fontSize: '14px' }}>
                                                            <p>{fileSelectionMessage}</p>
                                                        </Modal.Body>
                                                        <Modal.Footer style={{ borderTop: 'none' }}>
                                                            <Button variant="secondary"
                                                                onClick={() => setShowFileSelectionModal(false)}>
                                                                Close
                                                            </Button>
                                                        </Modal.Footer>
                                                    </Modal>


                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>

                            </div>
                        </div>
                    </div>
                </div>

            </main >
            <Footer />
        </div >
    );

}

export default GapsyResidualModifyRisk;
